import {
  Button,
  InputContainer,
  InputLabel,
  InputText,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@sellar-io/components";
import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export const AvailabilityTierNameForm = ({
  name,
  onNameChange,
  onSubmit,
  action,
  showAction = true,
  loading,
  helpContent,
}: {
  name: string;
  onNameChange: (name: string) => void;
  onSubmit: () => void;
  action: "Create" | "Update";
  showAction?: boolean;
  loading: boolean;
  helpContent?: ReactNode;
}) => (
  <form
    className="mx-auto flex w-full max-w-[920px] flex-col gap-2"
    onSubmit={(event) => {
      event.preventDefault();
      onSubmit();
    }}
  >
    <InputLabel>Name</InputLabel>
    <Tooltip placement="bottom" initialOpen={Boolean(helpContent)}>
      <TooltipTrigger className="w-full">
        <div className="flex">
          <InputContainer
            className={twMerge(
              "relative flex w-full items-center gap-1",
              showAction && "rounded-r-none",
            )}
          >
            <InputText
              value={name}
              onChange={(event) => onNameChange(event.target.value)}
            />
          </InputContainer>
          {showAction && (
            <Button
              type="submit"
              size="small"
              className="rounded-l-none px-4"
              loading={loading}
              disabled={loading || !name}
            >
              {action}
            </Button>
          )}
        </div>
      </TooltipTrigger>
      {helpContent && (
        <TooltipContent className="Tooltip w-[350px] rounded-lg border border-zinc-300 bg-white px-4 py-3 shadow-lg">
          {helpContent}
        </TooltipContent>
      )}
    </Tooltip>
  </form>
);
